import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useFormikContext } from "formik";
import React from "react";

import { MDButton } from "@/components/atoms/MDButton";
import { OrderFormData } from "@/components/screens/OrderFormPage/types";
import { OrderDataTabMessages } from "@/messages/order-form-page/order-data-tab.messages";

type Props = {
  isVisible: boolean;
  handleClose: () => void;
  messages: OrderDataTabMessages;
  disabled: boolean;
};

function DeliveryDialog({ isVisible, handleClose, messages, disabled }: Props) {
  const { values, errors, setFieldValue } = useFormikContext<OrderFormData>();

  const handleCancel = () => {
    setFieldValue("deliveryDate", values.deliveryDate);
    handleClose();
  };

  return (
    <Dialog open={isVisible} onClose={handleClose}>
      <DialogTitle>{messages.deliveryDialogTitle}</DialogTitle>

      <DialogContent sx={{ width: 400 }}>
        <Grid container spacing={3}>
          <Grid size={12}>
            <DatePicker
              label={messages.deliveryDateLabel}
              value={dayjs(values.deliveryDate)}
              onChange={(value) =>
                setFieldValue("deliveryDate", dayjs(value).startOf("day").toISOString())
              }
              slotProps={{
                textField: {
                  helperText: errors.deliveryDate,
                  error: Boolean(errors.deliveryDate),
                  fullWidth: true,
                  variant: "standard",
                  InputLabelProps: { shrink: true },
                },
              }}
              disabled={disabled}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <MDButton variant="gradient" color="light" onClick={handleCancel}>
          {messages.cancelButton}
        </MDButton>
        <MDButton variant="gradient" disabled={disabled} color="dark" onClick={handleClose}>
          {messages.updateButton}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeliveryDialog;
